import { GoogleMap, Marker, useJsApiLoader, InfoWindow } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

import NotificationsAlert from '../../services/NotificationsAlert.jsx';
import pin from "../../assets/marker.png";
import Conect from '../../../Api/Conect.js';

// eslint-disable-next-line
import '../css/style.css';
import LoadingOverlayManager from '../../services/LoadingOverlayManager.jsx';

const Mapa = () => {
    const history = useNavigate();
    const token = localStorage.getItem("restoken")
    const id_cli = localStorage.getItem('resid_cli')
    const veicles_ids = localStorage.getItem('resveicles_id')


    const [positions, setPositions] = useState([])
    const [centerPositions, setCenterPositions] = useState({ lat: -31.72978671059568, lng: -52.343938513840065, zoom: 13 })
    const [selectedPosition, setSelectedPosition] = useState(null)
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyChY0qKEv0A5uZX5eoibw0aSZbbs3zxfnM"
    })

    useEffect(() => {
        if (token === null) {
            NotificationsAlert("warning", "Desconectado", "Faça login para continuar!")
            history("/login");
        } else {
            setInterval(() => {
                getPositions()
            }, 30000);
        }
        getPositions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPositions = async () => {
        // if (!loaded) {
        //     LoadingOverlayManager.show();
        //     setLoaded(true)
        // }
        const response = await Conect.post(`/dmVoaWNsZXNVc2Vy${token}`, {
            vehicleIds: veicles_ids,
            id_cli: id_cli
        })
        // eslint-disable-next-line
        if (response.data.erro === true) {
            LoadingOverlayManager.hide();
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        else {
            let data = response.data.positionsVehicles
            if (response.data.positionsVehicles != null) {
                var dados = data.map((value, index) => {
                    return (<Marker
                        key={index}
                        position={{ lat: value.latitude, lng: value.longitude }}
                        onClick={() => {
                            setSelectedPosition(value)
                            setCenterPositions({ lat: value.latitude, lng: value.longitude, zoom: 19 })
                        }}
                        options={{
                            label: {
                                text: `${value.plate}`,
                                className: "map-marker"
                            }
                        }}
                        icon={{
                            url: pin,
                            scaledSize: new window.google.maps.Size(35, 35)
                        }}
                    />)
                })
            }
            // eslint-disable-next-line
            LoadingOverlayManager.hide();
            setPositions(dados)
        }
    }

    return (
        <>
            <div style={{ width: "100%", height: "90.7vh" }}>
                {isLoaded && (
                    <GoogleMap
                        mapContainerStyle={{ width: '100%', height: "100%" }}
                        center={{ lat: centerPositions.lat, lng: centerPositions.lng }}
                        zoom={centerPositions.zoom}
                    // options={{ styles: mapStyles }}
                    >
                        {positions != null && positions}

                        {selectedPosition && (
                            <InfoWindow
                                position={{
                                    lat: selectedPosition.latitude,
                                    lng: selectedPosition.longitude
                                }}
                                onCloseClick={() => {
                                    setCenterPositions({ lat: selectedPosition.latitude, lng: selectedPosition.longitude, zoom: 20 })
                                    setSelectedPosition(null)
                                }}

                            >
                                <div>
                                    <h3>{selectedPosition.plate}</h3>
                                    <h5 style={{ fontStyle: 'oblique' }}>{`${selectedPosition.description}`}</h5>
                                    <p>{`Velocidade: ${selectedPosition.speed.toFixed(2)}Km/h`}</p>
                                    <p>{`Ignição: ${selectedPosition.ignition === 0 ? 'Desligada' : 'Ligada'}`}</p>
                                    <p>{`Hodometro: ${(selectedPosition.odometerGps / 1000).toFixed(2)}Km`}</p>
                                    <p>{`Dia: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("DD/MM/yyyy")} Hora: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("HH:mm:ss")}`}</p>
                                </div>
                            </InfoWindow>
                        )}
                    </GoogleMap>
                )}
            </div>
        </>
    )
}

export default Mapa;